<template>
  <v-app-bar
    app
    class="header"
    :style="{ 'background-color': `${appConfig.color.mainDark} !important` }"
    dark
    :height="headerHeight"
  >
    <div
      v-show="!mobileBreakpoint"
      class="header__logo logo-wrap"
      data-test="logo-wrap"
      @click="onLogoClick"
    >
      <img
        v-if="appConfig.logoURL"
        class="logo-wrap__img"
        :src="appConfig.logoURL"
        alt="Крипто-Про"
        data-test="logo-custom"
      >
      <LogoCryptopro
        v-else
        data-test="logo-default"
      />
    </div>
    <v-tabs
      v-if="!lockButtons"
      v-model="activeTab"
      style="justify-self: center;"
      background-color="transparent"
      :height="headerHeight"
      :grow="mobileBreakpoint"
      :vertical="mobileBreakpoint"
    >
      <v-tabs-slider
        class="header__tabs-slider"
        :style="{ 'background-color': appConfig.color.mainLight }"
      />
      <v-tab
        v-for="tab in tabs"
        :key="tab.id"
        data-test="nav-tabs"
        class="header__tab pl-5 pr-5"
        active-class="header__tab--active"
        :style="{ 'color': appConfig.color.textLight }"
      >
        <span class="header__tab__text">{{ tab.title }}</span>
      </v-tab>
    </v-tabs>
  </v-app-bar>
</template>

<script>
import LogoCryptopro from '@/components/svg/LogoCryptopro'
import { mapActions, mapState } from 'vuex'
import { apiResetAllDocuments } from '@/api/api'

export default {
  name: 'MainHeader',
  components: {
    LogoCryptopro
  },

  props: {
    lockButtons: {
      type: Boolean,
      require: false,
      default: false
    }
  },

  data () {
    return {
      tabs: [
        { title: 'Проверка подписи', id: 0 },
        { title: 'Проверка сертификата', id: 1 }
      ],
      height: 75,
      appConfig: this.$appConfig
    }
  },

  computed: {
    ...mapState({
      storedActiveTab: state => state.activeTab
    }),

    activeTab: {
      get () {
        return this.storedActiveTab
      },
      set (tab) {
        this.changeTab(tab)
      }
    },

    headerHeight () {
      return (!this.mobileBreakpoint && this.height) || 110
    },
    mobileBreakpoint () {
      return this.$vuetify.breakpoint.mobile
    }
  },

  watch: {
    activeTab (tab) {
      switch (tab) {
        case 0:
          if (this.$router.currentRoute.name !== 'Signature') {
            this.$router.push('/signature')
          }
          break
        case 1:
          if (this.$router.currentRoute.name !== 'Certificate') {
            this.$router.push('/certificate')
          }
          break
      }
    }
  },

  methods: {
    ...mapActions(['resetStateByType', 'changeTab']),

    async onLogoClick () {
      this.resetStateByType('signature')
      this.resetStateByType('certificate')
      const reset = await apiResetAllDocuments()
      if (!reset) {
        this.$router.go(0)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .header {
    display: flex;
    justify-content: center;
    background-color: $color-main-dark !important;

    @media(max-width: $cp-laptop-breakpoint) {
      display: block;
    }

    &__tabs-slider {
      background-color: $color-main-light;

      @media(max-width: $cp-laptop-breakpoint) {
        width: 3px;
      }
    }

    &__tab {
      min-width: 265px;

      &--active {
        cursor: default;

        &:before {
          opacity: 0 !important;
        }

        & .header__tab__text {
          @media(max-width: $cp-laptop-breakpoint) {
            opacity: 0.5;
          }
        }
      }
    }

    &__logo {
      position: fixed;
      width: 150px;
      height: 50px;
      left: 100px;
      top: 13px;

      &:hover {
        cursor: pointer;
      }
    }
  }

  .logo-wrap {
    &__img {
      width: auto;
      max-width: 250px;
      height: 50px;
    }
  }
</style>
